import { Routes } from '@angular/router'
import { EnrollmentComponent } from 'app/enrollment'
import { ProfileComponent } from 'app/profile'
import { ClassScheduleComponent } from 'app/class-schedule'
import { EbookResourcesComponent } from 'app/ebook-resources'
import { PrivateTutoringComponent } from 'app/private-tutoring'
import { VideoResourcesComponent } from 'app/video-resources'
import { PdfResourcesComponent } from 'app/pdf-resources'
import { LsacComponent } from 'app/lsac'
import { VideoPlayerComponent } from 'app/video-players'
import { ResourceVideoGuard } from 'app/shared/guards'
import { PlaceholderComponent } from 'app/placeholder'
import { BmdComponent } from 'app/bmd'
import { OgExamsComponent } from 'app/og-exams'
import { QbanksComponent } from 'app/qbanks'

export const AUTHENTICATED_APP_ROUTES: Routes = [
  {
    path: 'resource/:id',
    loadChildren: './resource-view/resource-view.module#ResourceViewModule'
  },
  {
    path: 'profile/:id',
    loadChildren: './resource-view/resource-view.module#ResourceViewModule'
  },
  {
    path: 'enrollments',
    component: EnrollmentComponent
  },
  {
    path: 'class_schedule',
    component: ClassScheduleComponent
  },
  {
    path: 'ebooks',
    component: EbookResourcesComponent
  },
  {
    path: 'videos',
    component: VideoResourcesComponent
  },
  {
    path: 'videos/:id',
    component: VideoPlayerComponent,
    canActivate: [ResourceVideoGuard]
  },
  {
    path: 'downloads',
    component: PdfResourcesComponent
  },
  {
    path: '',
    loadChildren: './workspace/workspace.module#WorkspaceModule'
  },
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: 'private_tutoring',
    component: PrivateTutoringComponent
  },
  {
    path: 'lsac',
    component: LsacComponent
  },
  {
    path: 'placeholder',
    component: PlaceholderComponent
  },
  {
    path: 'bmd',
    component: BmdComponent
  },
  {
    path: 'ogexams',
    component: OgExamsComponent
  },
  {
    path: 'qbanks',
    component: QbanksComponent
  }
]



// WEBPACK FOOTER //
// ./src/app/authenticated-app/authenticated-app.routes.ts